function page(path) {
  return () => import(`@/views/${path}`).then(m => m.default || m)
}

export default [
  {
    path: "/login",
    component: {
      render(c) {
        return c("router-view")
      }
    },
    children: [
      {
        path: "",
        name: "Login",
        meta: {
          layout: "GuestLayout",
          requiresAuth: false
        },
        component: page("Auth/Login.vue")
      }
    ]
  },
  {
    path: "/",
    component: {
      render(c) {
        return c("router-view")
      }
    },
    children: [
      {
        path: "/",
        name: "HomePage",
        // redirect: '/dashboard',
        meta: {
          // layout: "MainLayout",
          requiresAuth: true
        }
        // component: page("Dashboard/NewDashboard.vue")
      },
      {
        path: "/dashboard",
        name: "dashboard",
        meta: {
          layout: "MainLayout",
          requiresAuth: true,
          breadcrumb: "dashboard"
        },
        component: page("Dashboard/NewDashboard.vue")
      },
      {
        path: "/admin",
        name: "AdminDefault",
        meta: {
          layout: "MainLayout",
          requiresAuth: true,
          breadcrumb: "dashboard"
        },
        component: page("Dashboard/AdminDefault.vue")
      },
      {
        path: "/summer-trip",
        name: "SummerTrip",
        meta: {
          layout: "MainLayout",
          requiresAuth: true,
          breadcrumb: "dashboard"
        },
        component: page("SummerTrip/ListEmployee.vue")
      },
      {
        path: "/summer-trip-data-master",
        name: "SummerTripDataMaster",
        meta: {
          layout: "MainLayout",
          requiresAuth: true,
          breadcrumb: "dashboard"
        },
        component: page("SummerTrip/Information.vue")
      },
      {
        path: "/employees",
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "/",
            name: "employees",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "employeeList"
            },
            component: page("Employees/ListEmployee.vue")
          },
          {
            path: "create",
            name: "employees.create",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "employeeCreate"
            },
            component: page("Employees/CreateEmployee.vue")
          },
          {
            path: "detail/:id",
            name: "employees.detail",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "employeeDetail"
            },
            component: page("Employees/EmployeeInformation.vue")
          },

          {
            path: "update/:id",
            name: "employees.update",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "employeeUpdate"
            },
            component: page("Employees/UpdateEmployee.vue")
          },
          {
            path: "resignation",
            name: "employees.resignation",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "employeeResign"
            },
            component: page("Employees/ListEmployeeResignation.vue")
          },
          {
            path: "/employee-level",
            name: "employee-level.list",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "employeeLevel"
            },
            component: page("EmployeeLevel/ListEmployeeLevel.vue")
          },
          {
            path: "/holiday-settings",
            name: "holiday-settings.list",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "holidaySettingList"
            },
            component: page("HolidaySettings/ListHolidaySetting.vue")
          },
          {
            path: "/timesheet-submit-period",
            name: "timesheet-submit-period.show",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "timesheetSubmitPeriod"
            },
            component: page("TimesheetSubmitPeriod/TimesheetSubmitPeriodSetting.vue")
          },
          {
            path: "/sabbatical-adjustments",
            name: "sabbatical-adjustments.list",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "sabbaticalAdjustment"
            },
            component: page("SabbaticalAdjustment/SabbaticalAdjustmentList.vue")
          },
          {
            path: "additional-days-off",
            name: "sabbatical-leave.import",
            meta: {
              layout: "MainLayout",
              requiresAuth: true
            },
            component: page("Employees/ImportDaysOff.vue")
          },
          {
            path: "days-off",
            name: "employees.days-off",
            meta: {
              layout: "MainLayout",
              requiresAuth: true
            },
            component: page("Employees/ListDaysOff.vue")
          }
        ]
      },
      {
        path: "/customers",
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "/",
            name: "customers",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "customerList"
            },
            component: page("Customers/ListCustomer.vue")
          },
          {
            path: "create",
            name: "customers.create",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "customerCreate"
            },
            component: page("Customers/CreateCustomer.vue")
          },
          {
            path: ":id",
            name: "customers.detail",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "customerDetail"
            },
            component: page("Customers/CustomerDetail.vue")
          },
          {
            path: ":id/edit",
            name: "customers.update",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "customerUpdate"
            },
            component: page("Customers/EditCustomer.vue")
          }
        ]
      },
      {
        path: "/projects",
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "/",
            name: "projects",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "projectList"
            },
            component: page("Projects/ProjectList.vue")
          },
          {
            path: "/project-overview",
            name: "projects.overview",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "projectList"
            },
            component: page("Projects/ProjectOverview.vue")
          },
          {
            path: "create",
            name: "projects.create",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "projectCreate"
            },
            component: page("Projects/ProjectCreate.vue")
          },
          {
            path: "resource-situation",
            // name: "projects.resource-situation",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "projectResource"
            },
            component: page("Projects/ResourceSituation.vue"),
            redirect: "resource-situation/resource-overview",
            children: [
              {
                path: "resource-overview",
                name: "resource-overview",
                meta: {
                  layout: "MainLayout",
                  requiresAuth: true,
                  breadcrumb: "projectResource",
                  active: "tab-chart"
                },
                component: page("Projects/ProjectResource/ResourceOverview.vue")
              },
              {
                path: "resource-employees",
                name: "resource-employees",
                meta: {
                  layout: "MainLayout",
                  requiresAuth: true,
                  breadcrumb: "projectResource",
                  active: "tab-list"
                },
                component: page(
                  "Projects/ProjectResource/ResourceEmployees.vue"
                )
              }
            ]
          },
          {
            path: "resource-situation/resource-employees/:id",
            name: "ResourceDetailLayout",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "resource"
            },
            component: page("Projects/Resource/ResourceDetailLayout.vue")
          },
          // {
          //   path: "resource-overview",
          //   name: "projects.resource-overview",
          //   meta: {
          //     layout: "MainLayout",
          //     // requiresAuth: true,
          //     breadcrumb: "projectResource"
          //   },
          //   component: page("Projects/ProjectResource/ResourceOverview.vue")
          // },
          {
            path: ":id",
            name: "projects.detail",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "projectDetail"
            },
            component: page("Projects/ProjectDetail.vue")
          },
          {
            path: "update/:id",
            name: "projects.update",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "projectUpdate"
            },
            component: page("Projects/ProjectUpdate.vue")
          },
          {
            path: ":id/detail",
            name: "projects.edit",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "projectEdit"
            },
            component: page("Projects/ProjectEdit.vue")
          },
          {
            path: "/projects/:id/effort",
            name: "projects.effort",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "projectManagementEffort"
            },
            component: page("Projects/ProjectEffort.vue")
          },
          {
            path: "/projects/:id/activities",
            name: "projects.activities",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "projectManagementActivities"
            },
            component: page("Projects/KickOffAndBonus/KickOffAndBonusList")
          },
          {
            path: "/projects/:id/review",
            name: "projects.review",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "projectManagementReview"
            },
            component: page("Projects/Review.vue")
          },
          {
            path: "/projects/:id/contract-management",
            name: "ContractManagement",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "projectContract"
            },
            component: page("Projects/ContractManagement.vue")
          }
        ]
      },
      {
        path: "/resource",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: ":id",
            name: "resource.effort",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "timesheetList"
            },
            component: page("Projects/Resource/ResourceEffort.vue")
          },
          {
            path: ":id",
            name: "resource.project-history",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "timesheetList"
            },
            component: page("Projects/Resource/ResourceEffort.vue")
          }
        ]
      },
      {
        path: "/timesheets",
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "/",
            name: "time-sheets",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "timesheetList"
            },
            component: page("TimeSheets/NewTimeSheetList.vue")
          },
          {
            path: "old",
            name: "time-sheets-old",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "timesheetList"
            },
            component: page("TimeSheets/TimeSheetList.vue")
          },
          {
            path: "import",
            name: "time-sheets.import",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "timesheetImport"
            },
            component: page("TimeSheets/ImportExcel.vue")
          },
          {
            path: "summary",
            name: "time-sheets.summary",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "timesheetSummary"
            },
            component: page("TimeSheets/TimeSheetSummary.vue")
          },
          {
            path: "list-submit",
            name: "time-sheets.list-submit",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "timesheetListSubmit"
            },
            component: page("TimeSheets/TimeSheetListSubmit.vue")
          },
          {
            path: "remind-history",
            name: "time-sheets.remind-history",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "remindHistory"
            },
            component: page("TimeSheets/RemindHistoryList.vue")
          },
          {
            path: "employee-timsheet-detail",
            name: "time-sheets.employee-timsheet-detail",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "employeeTimesheetDetail"
            },
            component: page("TimeSheets/DetailTimesheetEmployee.vue")
          }
        ]
      },
      {
        path: "/overtime-requests",
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "/",
            name: "overtime-requests",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "overtimeList"
            },
            component: page("OverTimeRequests/ListOverTimeRequest")
          },
          {
            path: "detail/:id",
            name: "overtime-requests.detail",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "overtimeDetail"
            },
            component: page("OverTimeRequests/DetailOverTimeRequest")
          }
        ]
      },
      {
        path: "/remote-requests",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/",
            name: "remote-requests",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "remoteList"
            },
            component: page("RemoteRequests/ListRemoteRequest")
          },
          {
            path: "detail/:id",
            name: "remote-requests.show",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "remoteDetail"
            },
            component: page("RemoteRequests/DetailRemoteRequest")
          }
        ]
      },
      {
        path: "/sabbatical-leave-requests",
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "/",
            name: "sabbatical-leave-requests",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "sabbaticalList"
            },
            component: page(
              "SabbaticalLeaveRequests/SabbaticalLeaveRequestList"
            )
          },
          {
            path: "detail/:id",
            name: "sabbatical-leave-requests.detail",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "sabbaticalDetail"
            },
            component: page(
              "SabbaticalLeaveRequests/SabbaticalLeaveRequestDetail"
            )
          }
        ]
      },
      {
        path: "/short-leave-requests",
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "/",
            name: "short-leave-requests",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "shortLeaveRequestList"
            },
            component: page(
              "ShortLeaveRequest/ShortLeaveRequestList"
            )
          }
        ]
      },
      {
        path: "/accounts",
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "/",
            name: "accounts",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "accountList"
            },
            component: page("Accounts/ListAccount.vue")
          }
        ]
      },
      {
        path: "/additional-timesheet",
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "/",
            name: "additional-timesheet.list",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "additionalTimeSheetList"
            },
            component: page("AdditionalTimesheet/ListAdditionalTimesheet")
          },
          {
            path: "detail/:id",
            name: "additional-timesheet.detail",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "additionalTimeSheetDetail"
            },
            component: page("AdditionalTimesheet/DetailAdditionalTimesheet")
          }
        ]
      },
      {
        path: "/contracts",
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "/",
            name: "contracts",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "contractList"
            },
            component: page("Contracts/ContractsList.vue")
          },
          {
            path: "create",
            name: "contracts.create",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "contractCreate"
            },
            component: page("Contracts/ContractCreate.vue")
          },
          {
            path: "update/:id",
            name: "contracts.update",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "contractUpdate"
            },
            component: page("Contracts/ContractUpdate.vue")
          }
        ]
      },
      {
        path: "/skill",
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "/",
            name: "skillsheet.list",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "skillList"
            },
            component: page("SkillSheet/ListSkillSheet")
          },
          {
            path: "/create",
            name: "skillsheet.create",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "skillCreate"
            },
            component: page("SkillSheet/CreateSkillSheet")
          },
          {
            path: "/update/:id",
            name: "skillsheet.update",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "skillUpdate"
            },
            component: page("SkillSheet/UpdateSkillSheet")
          }
        ]
      },
      {
        path: "/seating-chart",
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "/",
            name: "Seat Management",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "seat"
            },
            component: page("SeatingChart/ListSeatingChart")
          }
        ]
      },
      {
        path: "/type-work",
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "/",
            name: "Type Work",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "typeWork"
            },
            component: page("Employees/TypeWorkEmployee.vue")
          }
        ]
      },
      {
        path: "/403",
        name: "403",
        meta: {
          layout: "ErrorLayout",
          requiresAuth: false
        },
        component: page("Error_403.vue")
      },
      {
        path: "/skill-sheet",
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "detail/:id",
            name: "skill-sheet.detail",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "skillDetail"
            },
            component: page("SkillSheet/FormSkillSheet.vue")
          }
        ]
      },
      {
        path: "/sabbatical-compensate",
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "/",
            name: "Sabbatical.compensate",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "compensateList"
            },
            component: page("SabbaticalCompensate/SabbaticalCompensateList.vue")
          },
          {
            path: "detail/:id",
            name: "Sabbatical.compensate.detail",
            meta: {
              layout: "MainLayout",
              requiresAuth: true,
              breadcrumb: "compensateDetail"
            },
            component: page(
              "SabbaticalCompensate/SabbaticalCompensateDetail.vue"
            )
          }
        ]
      }
    ]
  },
  {
    path: "*",
    name: "404",
    meta: {
      layout: "ErrorLayout",
      requiresAuth: false
    },
    component: page("Error_404.vue")
  }
]
